import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { AuthService, ConfigService, TokenInterceptorService, ErrorInterceptorService } from '@shared';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

export function loadConfig(configService: ConfigService, authService: AuthService) {
  return async (): Promise<any> => {
    await configService.loadConfig();
    await authService.loadIdentityInfo();
    // await configService.mixPanelInit();
    return await configService.loadHubData();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: APP_INITIALIZER, useFactory: loadConfig, deps: [ConfigService, AuthService], multi: true },
    provideHttpClient(withInterceptorsFromDi())
  ]

};
